export const SERVER_URL = process.env.REACT_APP_API_URL ||  "https://api.kozoom.com";
export const UPLOADED_MEDIA_URL = `https://b-cdn.kozoom.com/`;
export const FEDERATION_IMAGE_URL = `https://kozoom.b-cdn.net/federations/`;
export const CHAT_SOCKET_SERVER_URL = process.env.REACT_APP_CHAT_SOCKET_SERVER_URL || "https://live-server.kozoom.com";
